import * as React from 'react';
import { SVGAttributes } from 'react';

const Qualitylodgings = (props: SVGAttributes<SVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="51" height="35" viewBox="0 0 51 35" {...props}>
        <defs>
            <clipPath id="b">
                <rect width="51" height="35" />
            </clipPath>
        </defs>
        <g id="a" clipPath="url(#b)">
            <g transform="translate(0 0)">
                <path
                    d="M16.2,27.444a15.591,15.591,0,0,0,4.3,5.07,10.414,10.414,0,0,0,5.259,1.86V35A21.351,21.351,0,0,1,20,33.914a25,25,0,0,1-5.8-2.741,28.331,28.331,0,0,1-4.732-3.729,18.789,18.789,0,0,1-4.449-2.408,13.066,13.066,0,0,1-3.7-4.669A15.106,15.106,0,0,1,0,13.82,13.571,13.571,0,0,1,3.844,3.935,12.529,12.529,0,0,1,13.151,0a12.06,12.06,0,0,1,8.985,3.944,13.779,13.779,0,0,1,3.8,9.954,14.068,14.068,0,0,1-2.7,8.554A13.3,13.3,0,0,1,16.2,27.444M12.917,1.507A7.14,7.14,0,0,0,7.2,4.052Q4.468,7.243,4.468,13.82q0,6.44,2.771,9.924a6.911,6.911,0,0,0,5.678,2.682,7.331,7.331,0,0,0,5.913-2.682q2.634-3.171,2.634-9.357A19.7,19.7,0,0,0,20.02,6.382a8.145,8.145,0,0,0-2.956-3.69,7.509,7.509,0,0,0-4.146-1.184"
                    transform="translate(0 0)"
                    fill="#000"
                />
                <path
                    d="M87.985,20.613l.644.137-2.263,7.2H65.878v-.725h.995a2.656,2.656,0,0,0,2.4-1.1,6.335,6.335,0,0,0,.41-2.9V6.108q0-2.485-.546-3.112a2.863,2.863,0,0,0-2.264-.861h-.995V1.41h11.98v.725a7.3,7.3,0,0,0-2.956.391,2.393,2.393,0,0,0-1.161,1.038,8.56,8.56,0,0,0-.312,3V23.236a5.437,5.437,0,0,0,.312,2.232,1.393,1.393,0,0,0,.722.607,12.61,12.61,0,0,0,3.044.2h1.932a13.952,13.952,0,0,0,4.273-.45,5.568,5.568,0,0,0,2.243-1.6,13.1,13.1,0,0,0,2.029-3.612"
                    transform="translate(-37.624 -0.803)"
                    fill="#000"
                />
            </g>
        </g>
    </svg>
);

export default Qualitylodgings;
